import * as React from "react";
import * as ReactDOM from "react-dom";

import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./SearchBox.scss";
import { searchOldUser, bindFriend,fetchNickname } from "../../utils/fetch";
import * as subpub from "../../utils/subpub";
import { Dialog } from "../../components";
import { IRanksInfo } from "../../IViewObject";


export interface ISearchBoxProps {
    /** class */
    className?: string;
    curBindUser: IRanksInfo
}
export interface ISearchBoxState {
    searchValue: string;
    oldUsers: oldUser[],
    curYyuid: string;
}
export interface oldUser {
    yyuid: string;
    passport: string
}
@pureRender
export class SearchBox extends React.Component<ISearchBoxProps, ISearchBoxState>{
    private searchDialog;
    constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            oldUsers: [{
                yyuid: "",
                passport: ""
            }],
            curYyuid: "",
        }
    }
    public render() {
        const { className } = this.props;
        const classNameSec = classnames(styles.sec, className);
        const { searchValue, oldUsers } = this.state;
        return (
            <div className={classNameSec}>

                搜索框
                {/* <div className={styles.search_box}  onClick={(e) => (this.showSearchList(true))} id="searchBox">
                    <input type="text" className={styles.search} value={searchValue} onKeyPress={this.searchUsers.bind(this)} onChange={this.changeValue.bind(this)}/>
                    <ul className={isShowSearchList ? styles.show : styles.hide} tabIndex={0}>
                        {oldUsers.map((item, index) => (this.renderSearchUsers(item, index)))}
                    </ul>
                </div> */}
                <div className={styles.search_box} >
                    <input type="text" className={styles.search} value={searchValue} onKeyPress={this.searchUsers.bind(this)} onChange={this.changeValue.bind(this)} placeholder="输入大使账号+回车键"/>
                    
                </div>

            </div>

        )
    }

    private renderSearchUsers(item, index) {
        return (
            <li onClick={(e) => (this.chooseUser(item.yyuid, item.passport))}>{item.passport}</li>
        )
    }

  
    private changeValue(e){
        let value = e.target.value || this.state.searchValue;
        this.setState({ searchValue: value })
    }

    private searchUsers(e) {
        if(e.keyCode!=13){
            return
        }
        if(this.searchDialog){
            this.searchDialog.close(true);                        
        }
        let value = e.target.value || this.state.searchValue;
        this.setState({ searchValue: value })
        
        if (!!value) {
            searchOldUser(value)
            .then((res: any) => {
                if (res.status == 200) {
                    this.setState({ oldUsers: res.data })
                    // 回车直接绑定
                    if(res.data.length>0){
                        this.chooseUser(res.data[0].yyuid,res.data[0].passport)
                    }else{
                        
                        let dialog = this.searchDialog = new f2eGameUI.Dialog({
                            classNames:{
                                component:"min-pop"
                            },
                            content:"查无此人",
                            buttons:[{
                                className:"btn-y",
                                callback:()=>{
                                    dialog.close(true)
                                }
                            }],
                        });
                  
                    }
                }
            })
            // .then((res: any) => {
            //     this.showSearchList(true)
            // })
        } else {
            this.setState({
                oldUsers: [{
                    yyuid: "",
                    passport: ""
                }],
                searchValue: ""

            })
            return;
        }
        
    }

    
    



    // 选择要绑定用户
    private chooseUser(yyuid, passport) {
    
        this.setState({ curYyuid: yyuid, searchValue: passport });

        let shareYyuid = Number(yyuid);
        let curBindYyuid = this.props.curBindUser.yyuid;

        if (!!shareYyuid) {
            if (curBindYyuid == shareYyuid){
                let dialog=this.searchDialog = new f2eGameUI.Dialog({
                    classNames:{
                        component:"min-pop"
                    },
                    content:"您已经绑定该用户",
                    buttons:[{
                        className:'btn-y',
                        callback:()=>{
                            dialog.close(true)
                        }
                    }]
                })
                return;
              };

            let dialog = this.searchDialog = new f2eGameUI.Dialog({
                classNames: {
                    component: "min-pop"
                },
                buttons: [{
                    className: "btn-nobind",
                    callback: () => {
                        dialog.close(true)
                    }
                }, {
                    className: "btn-bind",
                    callback: () => {
                        this.bind(shareYyuid)
                        dialog.close(true)

                    }
                }]
            })
            let contTips = "";
            if (!!curBindYyuid) {
                contTips = `是否解除已有绑定，并绑定${shareYyuid}为您新的游戏大使？`;
            } else {
                contTips = `是否绑定TA为您的游戏大使。绑定后将自动为TA投票`;

            }
            ReactDOM.render(
                <Dialog shareYyuid={shareYyuid} curBindYyuid={curBindYyuid} contTips={contTips} />,
                $('.f2e-dialog__body ')[0]
            )
        }


    }
    private bind(yyuid) {
        bindFriend(yyuid)
            .then((res: any) => {
                let cont = "";
                if (res.status == 200 && res.data) {
                    cont = "绑定成功！";
                    subpub.emit('bindSucc');

                } else if (res.status == 551) {
                    cont = res.message;
                } else {
                    cont = "绑定失败！";
                }
                let dialog = new f2eGameUI.Dialog({
                    classNames: {
                        component: "min-pop"
                    },
                    content: cont,
                    buttons: [{
                        className: "btn-y",
                        callback: () => {
                            dialog.close(true)
                        }
                    }]
                })
            })
    }
}

export default SearchBox;


// WEBPACK FOOTER //
// ./src/components/SearchBox/SearchBox.tsx